"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SelfProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var package_json_1 = require("../../package.json");
var GetSelfBlueprint = __importStar(require("@hiyllo/omni-common/src/blueprints/accounts/user/get-self"));
var SetOwnTimezoneBP = __importStar(require("@hiyllo/omni-common/src/blueprints/accounts/user/set-own-timezone"));
var client_1 = require("../contexts/client");
var cache_1 = require("../contexts/cache");
var self_1 = require("../contexts/self");
var main_1 = require("@hiyllo/stardate/main");
var tenant_1 = require("../contexts/tenant");
var SelfProvider = function (_a) {
    var _b, _c;
    var children = _a.children, authExtension = _a.authExtension, hasSavedLoginToken = _a.hasSavedLoginToken, LoadingComponent = _a.LoadingComponent, loginOptional = _a.loginOptional;
    var tenant = (0, tenant_1.useTenant)();
    var stardate = react_1["default"].useRef(new main_1.Stardate(main_1.StardateSourceEnum.frontendPackage, "omni-continuity@" + package_json_1.version, "self-provider", tenant)).current;
    var Cache = (0, cache_1.useCache)();
    var cachedSelf = (0, self_1.useCachedSelf)();
    var MoopsyClient = (0, client_1.useClient)();
    var getSelfMutation = MoopsyClient.useMutation(GetSelfBlueprint);
    var authState = authExtension.useAuthState();
    var _d = react_1["default"].useState(null), liveSelfData = _d[0], setLiveSelfData = _d[1];
    var refreshLiveSelfData = react_1["default"].useCallback(function () {
        if (authState == null) {
            return stardate.log({
                kind: main_1.StardateLogKind.warning,
                message: "Refusing to refresh live self data as authState is null",
                data: {
                    version: package_json_1.version
                }
            });
        }
        getSelfMutation.call(null).then(function (response) {
            setLiveSelfData(response);
        })["catch"](function (err) {
            if (err.code !== 408) {
                stardate.log({
                    kind: main_1.StardateLogKind.error,
                    message: "Failed to refresh live self data",
                    data: {
                        authState: authState,
                        version: package_json_1.version
                    },
                    error: err
                });
            }
        });
    }, [authState, getSelfMutation]);
    var callSetOwnTimezoneMutation = MoopsyClient.useMutation(SetOwnTimezoneBP).call;
    var hasCachedSelf = cachedSelf != null;
    var hasAuthState = authState != null;
    var isAuthenticated = hasSavedLoginToken || hasCachedSelf || hasAuthState;
    react_1["default"].useEffect(function () {
        if (authState != null) {
            stardate.log({
                kind: main_1.StardateLogKind.trace,
                message: "Refreshing live self data"
            });
            refreshLiveSelfData();
        }
    }, [authState]);
    // Sync timezone to server
    react_1["default"].useEffect(function () {
        var currentTimezone = moment_timezone_1["default"].tz.guess();
        if ((liveSelfData === null || liveSelfData === void 0 ? void 0 : liveSelfData.user) != null) {
            if (liveSelfData.user.timezone !== currentTimezone) {
                void callSetOwnTimezoneMutation({ timezone: currentTimezone });
            }
        }
    }, [callSetOwnTimezoneMutation, liveSelfData]);
    react_1["default"].useEffect(function () {
        if ((liveSelfData === null || liveSelfData === void 0 ? void 0 : liveSelfData.user) != null) {
            void Cache.set("self", liveSelfData.user);
        }
    }, [liveSelfData]);
    if (isAuthenticated) {
        var self_2 = (_b = liveSelfData === null || liveSelfData === void 0 ? void 0 : liveSelfData.user) !== null && _b !== void 0 ? _b : cachedSelf;
        if (self_2 == null) {
            return (0, jsx_runtime_1.jsx)(LoadingComponent, {});
        }
        return ((0, jsx_runtime_1.jsx)(self_1.SelfContext.Provider, __assign({ value: {
                data: {
                    self: self_2,
                    homeLocation: (_c = liveSelfData === null || liveSelfData === void 0 ? void 0 : liveSelfData.homeLocation) !== null && _c !== void 0 ? _c : null
                },
                refresh: refreshLiveSelfData
            } }, { children: children })));
    }
    if (loginOptional) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    else {
        return (0, jsx_runtime_1.jsx)(LoadingComponent, {});
    }
};
exports.SelfProvider = SelfProvider;
